export enum FrageSprachkenntnisse {
  GRUNDKENNTNISSE = 'grundkenntnisse',

  BEFRIEDIGEND = 'befriedigend',

  GUT = 'gut',

  SEHR_GUT = 'sehr_gut',
}
